const domains = {
  url: process.env.VUE_APP_API,
  prod: 'https://api-cdg.web-abondance.com',
  local: 'http://web-abondance.local'
};

export default domains.url;
export { domains };
